import { NgModule } from '@angular/core';
import { ProductStoreModule } from './store/product-store.module';

@NgModule({
  imports: [ProductStoreModule],
})
export class ProductDataAccessModule {}
